import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { COMPANY } from "@/data/site";

const SERVICES = [
  "Drainage", "Groundworks", "Residential Landscaping",
];

const SERVICE_LINKS = {
  "Drainage": "/drainage",
  "Groundworks": "/groundworks",
  "Residential Landscaping": "/residential-landscaping",
};

export default function Footer() {
  return (
    <footer className="bg-[#050505] pt-20 pb-10 border-t border-[#181818] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Logo />
            <p className="text-[#9A9A9A] mt-6 text-sm leading-relaxed max-w-xs">
              Professional groundworks, drainage and landscaping in Edinburgh, done right the first time.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href={COMPANY.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"
                 className="w-10 h-10 inline-flex items-center justify-center border border-[#181818] text-white hover:text-[#F28C00] hover:border-[#F28C00] transition-colors"
                 data-testid="footer-instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href={COMPANY.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"
                 className="w-10 h-10 inline-flex items-center justify-center border border-[#181818] text-white hover:text-[#F28C00] hover:border-[#F28C00] transition-colors"
                 data-testid="footer-facebook">
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white uppercase font-display font-bold tracking-[0.2em] text-sm mb-6">Services</h4>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s}>
                  <Link to={SERVICE_LINKS[s]} className="text-[#9A9A9A] hover:text-[#F28C00] text-sm transition-colors">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white uppercase font-display font-bold tracking-[0.2em] text-sm mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-[#9A9A9A] hover:text-[#F28C00] text-sm transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-[#9A9A9A] hover:text-[#F28C00] text-sm transition-colors">About Us</Link></li>
              <li><Link to="/testimonials" className="text-[#9A9A9A] hover:text-[#F28C00] text-sm transition-colors">Testimonials</Link></li>
              <li><Link to="/contact" className="text-[#9A9A9A] hover:text-[#F28C00] text-sm transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white uppercase font-display font-bold tracking-[0.2em] text-sm mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-[#9A9A9A] text-sm">
                <Phone className="w-4 h-4 mt-0.5 text-[#F28C00] shrink-0" />
                <a href={`tel:${COMPANY.phoneShort.replace(/\s/g, "")}`} className="hover:text-[#F28C00] transition-colors">
                  {COMPANY.phoneShort}
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#9A9A9A] text-sm">
                <Mail className="w-4 h-4 mt-0.5 text-[#F28C00] shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-[#F28C00] transition-colors break-all">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#9A9A9A] text-sm">
                <MapPin className="w-4 h-4 mt-0.5 text-[#F28C00] shrink-0" />
                <span>{COMPANY.city}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#181818] mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-[#666] text-xs">
          <p>
            © 2024 City Civils Construction Ltd. All Rights Reserved. | Designed By{" "}
            <a
              href="https://jayalminshawi.com/"
              target="_blank"
              rel="noreferrer"
              className="text-[#9A9A9A] hover:text-[#F28C00] underline-offset-2 hover:underline transition-colors"
              data-testid="footer-designer-link"
            >
              Jay Alminshawi
            </a>{" "}
            - Powered By Webflow
          </p>
        </div>
      </div>
    </footer>
  );
}
